import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M237.5 1.638H1.5V237.5h236z" }, null, -1),
    _createElementVNode("g", { "stroke-linecap": "butt" }, [
      _createElementVNode("path", { d: "M215.97 1.638V119.5M173.05 1.638V119.5m4.967-117.862V119.5M189.472 1.638V119.5m-37.953-118v118m-21.392-118v118M85.55 1.638V119.5M65.675 1.638V119.5m4.97-117.862V119.5M44.282 1.638V119.5M39.316 1.638V119.5M29.378 1.638V119.5m79.219 118V119.638m4.968 117.862V119.638m9.937 117.862V119.638M138.408 237.5V119.638M1.5 119.5h236m-214.747.138V237.5m-4.968-117.862V237.5m47.89-118v118m4.97-118v118m102.404-118v118m21.392-118v118M146.55 1.5v118m42.922 0v118m26.499-118v118m4.967-118v118" })
    ], -1)
  ])))
}
export default { render: render }